import { createFileRoute } from "@tanstack/react-router";
import { ACCESS_PAGE_SUBTITLE } from "@/lib/labels";
import { AccessPage } from "@/pages/AccessPage";

export const Route = createFileRoute("/_authenticated/admin")({
  head: () => ({
    meta: [
      { title: "Oxley management" },
      { name: "description", content: ACCESS_PAGE_SUBTITLE },
    ],
  }),
  component: AccessPage,
});
